import { useRouter } from "next/navigation";

import Headline from "@/partials/elements/Headline";
import ViewAll from "@/partials/elements/ViewAll";

export default function FeaturedEventInfo() {
  const router = useRouter();

  return (
    <div className="flex justify-between items-center pt-12 md:pt-16 pb-4 md:pb-6">
      <Headline text={"Featured Event"} />
      {/* <ViewAll action={() => router.push("/events")} text={"View All"} /> */}
    </div>
  );
}
